<template>
  <Popup :ref="(el) => popup = el"
         :hide-title="true"
         @onClose="hide"
  >
    <form>
      <div class="popup__content mb-sm">
        {{ config?.title }}
      </div>
      <div class="popup__controls">
        <button type="button" @click="hide" class="btn popup__close">
          <span class="text-capitalize-first">{{ config?.cancelTitle ?? $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="onOkClick" class="btn btn--accept">
          <span class="text-capitalize-first">{{ config?.okTitle ?? $t('button.ok') }}</span>
        </LoaderButton>
      </div>
    </form>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import {api} from "@/service/APIClient";

export default defineComponent({
  methods: {$t},
  emits: ['state:updated'],
  components: {LoaderButton, FormInputWrapper, Popup},
  setup(props, {emit}) {

    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const state = reactive({
      config: null as any
    });

    const onOkClick = async () => {
      if (state.config.onOkClick) {
        await state.config.onOkClick();
      }

      hide()
    }

    const show = (config: any) => {
      state.config = config
      popup.value?.show()
    }

    const hide = () => {
      state.config = null
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      onOkClick,
      popup,
      helper,
      show,
      hide,
    }
  }
})
</script>
